import { MODIFY_CART_LINE_ITEM_ERROR, MODIFY_CART_LINE_ITEM_REQUEST, MODIFY_CART_LINE_ITEM_SUCCESS } from '../types';
import { useHelper } from '../helpers';
export const modifyLineItemRequest = lineItemId => {
  return {
    type: MODIFY_CART_LINE_ITEM_REQUEST,
    lineItem: lineItemId
  };
};
export const modifyLineItemSuccess = cart => {
  return {
    type: MODIFY_CART_LINE_ITEM_SUCCESS,
    data: cart
  };
};
export const modifyLineItemError = function (error) {
  let meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: MODIFY_CART_LINE_ITEM_ERROR,
    error: true,
    meta,
    payload: error
  };
};
export const modifyLineItem = options => {
  const {
    attributes,
    lineItemId
  } = options;
  return async (dispatch, getState, _ref) => {
    let {
      chord
    } = _ref;
    const {
      withCart
    } = useHelper(dispatch, getState);
    try {
      dispatch(modifyLineItemRequest(lineItemId));
      await withCart(chord.oms.updateLineItem)(null, lineItemId, attributes);
      const updatedCart = await withCart(chord.oms.getOrder)();
      dispatch(modifyLineItemSuccess(updatedCart));
      return updatedCart;
    } catch (error) {
      dispatch(modifyLineItemError(error, {
        lineItemId
      }));
      throw error;
    }
  };
};